export function parseNumber(value: any, defaultNumber = 0): number {
  const number: any = Number(value);

  if (isNaN(number)) {
    return defaultNumber;
  } else {
    return number;
  }
}

export function roundToMultiple(value: number, multiple: number) {
  return Math.ceil(value / multiple) * multiple;
}
